module.exports = __webpack_public_path__ + "img/中繼站2_炸彈.872f4d2c.png";